/**
 * Resolve a Lucide icon component from a kebab/snake name (e.g. `chevron-down` → ChevronDown).
 * @param {Record<string, unknown>} lucideModule - typically `import * as LucideIcons from 'lucide-react'`
 */
export function getLucideIconByName(lucideModule, name) {
  if (!name || !lucideModule) return null;
  const pascalName = String(name)
    .split(/[-_]/)
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join('');
  return lucideModule[pascalName] || null;
}
